module.exports = __webpack_public_path__ + "static/jamiejones_2-31316d67809eb844037782f180141b0e.jpg";